import React from "react";
import { FaPercent, FaRegSmile, FaCheckCircle } from "react-icons/fa";
import about1 from "../assets/about.webp"
import about from "../assets/rank2.webp"
import about2 from "../assets/rank3.webp"
import about3 from "../assets/rank4.webp"
import AboutComponent from "./rankridge_about_page";
import CommonImageSlider from "./comandata";
import { aboutImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import SeoMeta from "./seometa";
import { AboutHeader } from "./aboutheader";
import { Helmet } from "react-helmet-async";

const seopages = {
    title: "About Rankridge Schools | Rankridge Excellence in Education Hyderabad",
    description:
      " Learn about Rankridge Schools, Hyderabad’s trusted name in quality education, academic excellence, and all-round growth.",
    keywords: " about rankridge schools, rankridge international school about, best school in hyderabad history, rankridge school vision, rankridge school mission, hyderabad top schools information, rankridge school achievements, rankridge school branches, rankridge education excellence, best cbse school background, state board school excellence hyderabad, rankridge leadership in education, rankridge teaching philosophy, quality education in hyderabad, ",
    canonical_path: "https://rankridgeschools.com/about-us/",
    og_description: "Learn about Rankridge Schools, Hyderabad’s trusted name in quality education, academic excellence, and all-round growth.",
    og_image: "",
  };
  const ogImg = seopages.og_image || (Array.isArray(aboutImages) ? aboutImages[0] : aboutImages);


export default function About() {
  return (
    <div >



       <Helmet>
              <title>{seopages.title}</title>
              <meta name="description" content={seopages.description} />
              <meta name="keywords" content={seopages.keywords} />
              {seopages.canonical_path && (
                <link rel="canonical" href={seopages.canonical_path} />
              )}
      
              {/* Open Graph */}
              <meta property="og:type" content="website" />
              <meta property="og:title" content={seopages.title} />
              <meta property="og:description" content={seopages.description} />
              {ogImg && <meta property="og:image" content={ogImg} />}
              {seopages.canonical_path && (
                <meta property="og:url" content={seopages.canonical_path} />
              )}
              <meta property="og:site_name" content="Rankridge Schools" />
      
              {/* Twitter */}
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content={seopages.title} />
              <meta name="twitter:description" content={seopages.description} />
              {ogImg && <meta name="twitter:image" content={ogImg} />}
            </Helmet>

                       <h6  className="text-xl text-center text-black font-extrabold">Rankridge: Redefining Learning &  Realizing Dreams. </h6>
  <section className="flex flex-wrap m-1">
      
      {/* Right half on md+, full width on mobile */}
      <div className="w-full  m-4">
        {/* <CommonImageSlider images={aboutImages}  /> */}
        <AboutHeader />
      </div>
{/* Left half on md+, full width on mobile */}
      <div className="w-full  mt-8 m-4 ">
        <CallandRegisterComponent />
      </div>
    </section>
{/*      
    <section className="bg-white px-1 md:px-12 py-1 text-green-900 mt-3">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

        <div>
          
          <h1 className="text-3xl md:text-4xl font-bold mt-2 mb-4 text-center ms-4 me-4">
            About Rankridge International Schools 
          </h1>
          <p className="text-gray-700 text-base md:text-lg text-start ms-8 me-8">
Nurturing Academic Brilliance with Global Vision Rankridge Schools is a premier K–12 educational institution offering a transformative learning experience from Pre-Primary to Grade 12. Based in Hyderabad, we provide a world-class academic ecosystem that blends national and international curricula with a deep commitment to values, leadership, and life skills. At Rankridge, we believe that every child is a leader in the making  and we create the environment, guidance, and opportunities to make that vision a reality.
</p>

        </div>

        <div className="flex justify-center mb-8">
          <img  src={about1} alt="Students collaborating"
            className="w-full max-w-md rounded-xl shadow-lg"/>
        </div>
      </div>
    </section> */}

     <section className="bg-[#20b2aa] py-1 px-1 md:px-1 lg:px-2 text-center md:text-left lg:text-left">
         <AboutComponent />
    </section>

            {/* <SeoMeta seopages={seopages} /> */}
    
    </div>
  );
}
